var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShieldIcon = function SvgShieldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.306c-.064 2.446-.49 4.795-1.625 6.953-1.041 1.98-2.532 3.476-4.363 4.598-.338.207-.686.175-1.031-.002C3.063 13.36 1.177 10.96.392 7.589c-.35-1.5-.424-3.028-.381-4.564.018-.648.398-.993 1.093-1.053 1.348-.117 2.641-.45 3.84-1.14.315-.181.621-.384.921-.593.47-.327.917-.32 1.38.03a8.241 8.241 0 0 0 3.754 1.598c.281.043.564.077.847.1.84.07 1.167.444 1.154 1.339",
    fill: "#55CCDE",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield-icon.49acd57c.svg";
export { ForwardRef as ReactComponent };